import { connect } from 'react-redux';
import * as R from 'ramda';
import {
  getCarrierPerformance,
  getItem,
  setCarrierSortColumn,
  setCarrierSortDirection,
} from '../../store/rackWaitTimesSlice';
import CarrierPerformance from './CarrierPerformance';

const mapState = R.applySpec({
  carrierPerformance: getCarrierPerformance,
  carrierSortColumn: getItem('carrierSortColumn'),
  carrierSortDirection: getItem('carrierSortDirection'),
});

const mapDispatch = {
  setCarrierSortColumn,
  setCarrierSortDirection,
};

export default connect(mapState, mapDispatch)(CarrierPerformance);
